import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';

const getEvents = () =>
  graphqlHelper({
    query: graphql.event.queries.get,
    variables: {},
  });

export {
  // eslint-disable-next-line import/prefer-default-export
  getEvents,
};



// WEBPACK FOOTER //
// ./src/services/event.js